import DocsTask from './styled';

export default DocsTask;
